import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinkDirective } from './directives';

@NgModule({
  declarations: [LinkDirective],
  exports: [LinkDirective],
  imports: [CommonModule],
})
export class LinkModule {}
